import React from 'react';
import SectionUnlock from '../components/SectionUnlock';
import InteractiveTimeline from '../components/InteractiveTimeline';

const AboutSection = ({ unlockedSections }) => {
  return (
    <section id="about" className="py-20 bg-white relative">
      <SectionUnlock sectionId="about" unlockedSections={unlockedSections}>
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">My Journey</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              A passionate developer with a strong foundation in computer science and a proven track record of innovation.
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <InteractiveTimeline />
          </div>
        </div>
      </SectionUnlock>
    </section>
  );
};

export default AboutSection;